export default __webpack_public_path__ + "static/media/(25).b5812f2d.JPG";